/**
 * Normalizes a BeeOS blog record for Ask Simpo's `open_from` / `sendData` contract.
 * Mirrors the fields consumed by ask-simpo's `buildHostBlogPrefill`.
 */
export function buildAskSimpoBlogSendData(blog: any): any {
  if (!blog) return { isEdit: true };

  const blogId = blog.id || blog.blogId || blog._id || blog.recordId || blog.blog_id;
  const blocks = Array.isArray(blog.blocks)
    ? blog.blocks.filter((block: any) => block && typeof block === 'object' && block.type)
    : [];

  return {
    id: blogId,
    blogId: blogId,
    _id: blogId,
    blog_id: blogId,
    recordId: blogId,
    record_id: blogId,
    postTitle: blog.postTitle || blog.title || blog.blogTitle || '',
    title: blog.postTitle || blog.title || blog.blogTitle || '',
    newPostTitle: blog.postTitle || blog.title || '',
    articleSlug: blog.articleSlug || blog.slug || '',
    slug: blog.articleSlug || blog.slug || '',
    postSummary: blog.postSummary || blog.excerpt || blog.summary || '',
    excerpt: blog.postSummary || blog.excerpt || blog.summary || '',
    summary: blog.postSummary || blog.excerpt || '',
    description: blog.postSummary || blog.excerpt || '',
    blocks,
    blogMeta: blog.blogMeta || null,
    keyWords: blog.keyWords || null,
    keywords: blog.keyWords || blog.keywords || null,
    tags: blog.tags || null,
    author: blog.author || null,
    authorName: blog.authorName || null,
    categoryId: blog.categoryId || null,
    category_id: blog.categoryId || null,
    categoryName: blog.categoryName || null,
    category_name: blog.categoryName || null,
    category: blog.categoryName || blog.category || null,
    blogStatus: blog.blogStatus || null,
    img: blog.img || '',
    imageUrl: blog.imageUrl || blog.img || '',
    content_html: blog.content_html || blog.contentHtml || '',
    contentHtml: blog.content_html || blog.contentHtml || '',
    isEdit: true,
  };
}

export function blogHasEditorContent(blog: any): boolean {
  if (!blog) return false;
  if (Array.isArray(blog.blocks) && blog.blocks.length > 0) return true;
  const html = blog.content_html || blog.contentHtml;
  return typeof html === 'string' && html.trim().length > 0;
}
